var AppConsts = /** @class */ (function () {
    function AppConsts() {
    }
    AppConsts.authorization = {
        encrptedAuthTokenName: 'enc_auth_token',
        enableExternalLogin: true
    };
    AppConsts.userManagement = {
        defaultAdminUserName: 'admin'
    };
    AppConsts.localization = {
        defaultLocalizationSourceName: 'Hamazon'
    };
    AppConsts.platform = 'Micro';
    AppConsts.AppName = process.env.VUE_APP_NAME;
    return AppConsts;
}());
export default AppConsts;
